@if (fields && product) {
  <div>
    <wl-generic-price-info
      class="d-block mx-2"
      [prefixLabel]="fields.SaveLabelLeft"
      [suffixLabel]="fields.SaveLabelRight"
      [price]="product.yearlySavings"
    ></wl-generic-price-info>

    <wl-generic-offer-info
      [marginTop]="false"
      [productInfo]="productInfo"
    ></wl-generic-offer-info>
  </div>
}
